import { dispatchNetworkEvent } from './event-bus';
import config from './config';

const scope = typeof globalThis !== 'undefined'
	? globalThis
	: typeof window !== 'undefined'
		? window
		: typeof self !== 'undefined'
			? self
			: {};

const patchKey = '__epicNetworkGuardPullPatched';
let pullGuardInterval = null;

const pullErrorState = {
	count: 0,
	timer: null
};

const resetPullErrorState = () => {
	pullErrorState.count = 0;

	if (pullErrorState.timer) {
		clearTimeout(pullErrorState.timer);
		pullErrorState.timer = null;
	}
};

const trackPullError = error => {
	pullErrorState.count += 1;

	if (!pullErrorState.timer) pullErrorState.timer = setTimeout(resetPullErrorState, config.pullErrorWindow);

	dispatchNetworkEvent('epic:network:pull_error', {
		error,
		count: pullErrorState.count
	});

	if (pullErrorState.count >= config.pullErrorThreshold) {
		dispatchNetworkEvent('epic:network:unstable', {
			source: 'pull',
			error,
			count:  pullErrorState.count
		});

		resetPullErrorState();
	}
};

const patchPullClient = () => {
	const bx = scope && scope.BX ? scope.BX : null;
	const PullClient = bx && bx.PullClient ? bx.PullClient : null;

	if (!PullClient || !PullClient.prototype) return false;

	if (PullClient.prototype[patchKey]) return true;

	const original = PullClient.prototype.onWebSocketError;

	// eslint-disable-next-line func-name-matching
	PullClient.prototype.onWebSocketError = function onWebSocketErrorWrapper(error) {
		trackPullError(error);

		if (typeof original === 'function') return original.apply(this, arguments);

		return undefined;
	};

	PullClient.prototype[patchKey] = true;
	return true;
};

const ensurePullGuard = () => {
	if (patchPullClient()) {
		if (pullGuardInterval) {
			clearInterval(pullGuardInterval);
			pullGuardInterval = null;
		}

		return;
	}

	if (pullGuardInterval) return;

	pullGuardInterval = setInterval(() => {
		if (patchPullClient()) {
			clearInterval(pullGuardInterval);
			pullGuardInterval = null;
		}
	}, 500);
};

export { ensurePullGuard };
